@if (!showMap()) {
  <div class="flex gap-2 items-center">
    <gmp-place-autocomplete class="flex-1 text-sm"
      [placeholder]="placeHolderName()"
      (gmp-select)="onPlaceSelect($event)"
      #search />
    <p-button label="Auto-detect"
      icon="pi pi-crosshair"
      size="small"
      (onClick)="onAutoDetectLocation()"
      [loading]="isDetectingLocation" />
  </div>
}

@if (showMap()) {
  <div #map style="height: 300px; width: 100%;"></div>
}